window.adev = window.adev || {};

(function ($) {
	"use strict";

	adev = {
		init: function() {
			this.header();
			this.filter();
			this.productImages();
			this.productCard();
		},
		header: function(){
			let header = $('[data-header-height]')
			let headerHeight = header.outerHeight() + 20;
			
			$('.adev-product-info').css({
				'--adev-sticky-height': headerHeight + 'px'
			})
		},
		productImages: function(){
			if(!$('[data-adev-media-wrapper]').length) return;
			
			if($(window).outerWidth() > 768) {
				$('[data-adev-media-wrapper].slick-initialized').slick('unslick')
			} else {
				$('[data-adev-media-wrapper]').not('.slick-initialized').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite:true,
					adaptiveHeight: true,
					arrows: true,
					dots:true,
					prevArrow: '<div class="slick-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><g stroke-width="1.5" fill="none"><path d="M15 6l-6 6l6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></g></svg></div>',
					nextArrow: '<div class="slick-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><g stroke-width="1.5" fill="none"><path d="M9 6l6 6l-6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></g></svg></div>'
				});
			}

			Fancybox.bind('[data-fancybox="gallery"]');
		},
		filter: function(){
			$('[data-adev-filter-wrapper]').on('change', function(e){
				$(this).submit()
			})
			
			$('[data-adev-switch-layout]').on('click', function(e){
				e.preventDefault()
				let url = new URL(window.location.href);
				url.searchParams.set('view', $(this).data('adev-switch-layout'))
				window.location.assign(url)
			})
		},
		productCard: function(){
			var selfthis = this
			$('[data-adev-add-variant]').on('click', function(e){
				let self = $(this)
				let variantId = self.data('variant-id')

				jQuery.ajax({
					type: 'POST',
					url: '/cart/add.js',
					data: 'quantity=1&id=' + variantId,
					dataType: 'json',
					success: function(line_item) { 
					  console.log(line_item);
					  
					  selfthis.ajaxGet('/cart.js')
					  .done(function(cart){
						console.log(cart);
						var d = {
							detail: {
							  cart: cart,
							},
							bubbles: true,
						}

						document.dispatchEvent(new CustomEvent('theme:cart:change', d))
						
						const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
						cartDrawer.dispatchEvent(
							new CustomEvent('theme:drawer:open', {
							  bubbles: false,
							})
						);

					  })
					},
					error: function(XMLHttpRequest, textStatus) {
					  console.log(XMLHttpRequest, textStatus);
					  alert(XMLHttpRequest.responseJSON.description)
					}
				});

			})
		},
		ajaxGet: function(url){
			return $.ajax({
				url: url,
				type: 'GET',
				dataType: 'json',
			})
		},
		ajaxPost: function(url, data){
			return $.ajax({
				url: url,
				type: 'POST',
				data: data
			})
		}
	}

	adev.init();

}(jQuery));